import React, { forwardRef } from 'react';

import { CustomBadge } from './MuiBadge.style';

import type { BadgeProps } from '@mui/material';

export type SizeBadge = 'small' | 'default';
type MuiBadgePropsType = {
  size?: SizeBadge;
  isSelected?: boolean;
  disableBackground?: boolean;
} & Partial<BadgeProps>;
export const MuiBadge = forwardRef<HTMLDivElement, MuiBadgePropsType>((props, ref) => {
  const { variant, size, disableBackground, ...restProps } = props;

  return (
    <CustomBadge
      {...restProps}
      ref={ref}
      variant={variant}
      badgeVariant={variant}
      size={size}
      disableBackground={disableBackground}
    />
  );
});
